exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._21IxTZGpgY4ANFp62m4B5J{margin-right:40px;width:275px;flex-grow:0}._21IxTZGpgY4ANFp62m4B5J._12LCspy57Fv3cZ3qf5vZ5M{width:100%;margin-left:auto;margin-right:auto}._21IxTZGpgY4ANFp62m4B5J a,._21IxTZGpgY4ANFp62m4B5J a:visited{color:#212121}._21IxTZGpgY4ANFp62m4B5J a:hover{color:#fa6400}._1nYo9g_zsvgTymxWUnG_B{padding:15px 20px 20px 20px;min-height:165px;text-align:left;line-height:26px;display:flex;flex-flow:column wrap}._1nYo9g_zsvgTymxWUnG_B ._3HbvmJXFMLeSQgSnHy0x-3{flex-grow:0}._1nYo9g_zsvgTymxWUnG_B :hover{color:#fa6400;text-decoration:none;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"zoneCard": "_21IxTZGpgY4ANFp62m4B5J",
	"collapsed": "_12LCspy57Fv3cZ3qf5vZ5M",
	"content": "_1nYo9g_zsvgTymxWUnG_B",
	"country": "_3HbvmJXFMLeSQgSnHy0x-3"
};